<template>
  <div>
    <Title
      :pages="[
        { icon: 'circle', path: '/' + Constant.SECTION_MONEY_ACCOUNTS, page: 'CUENTAS TESORERÍA' },
        { icon: 'circle', page: 'MOVIMIENTOS: ' + moneyAccountName },
      ]"
    ></Title>

    <v-container fluid>
      <v-card class="mb-3">
        <div class="row ma-0 pa-3">
          <div class="col-md-4">
            <v-menu
              ref="desde_selected"
              v-model="desde_selected_open"
              :close-on-content-click="false"
              :close-on-click="false"
              :return-value.sync="desde_selected"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="desde_selected" label="Desde" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
              </template>
              <v-date-picker v-model="desde_selected" type="date" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="desde_selected_open = false">Cancelar</v-btn>
                <v-btn text color="primary" @click="$refs.desde_selected.save(desde_selected)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </div>

          <div class="col-md-4">
            <v-menu
              ref="hasta_selected"
              v-model="hasta_selected_open"
              :close-on-content-click="false"
              :close-on-click="false"
              :return-value.sync="hasta_selected"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="hasta_selected" label="Hasta" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
              </template>
              <v-date-picker v-model="hasta_selected" type="date" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="hasta_selected_open = false">Cancelar</v-btn>
                <v-btn text color="primary" @click="$refs.hasta_selected.save(hasta_selected)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </div>

          <div class="col-md-4 d-flex justify-end align-center">
            <v-btn color="blue-grey" dark :loading="dialog_export" @click="exportFile()" class="mr-2">Exportar <font-awesome-icon icon="download" class="ml-2" /></v-btn>
            <v-btn color="info" @click="loadBalances" :loading="loading">Buscar</v-btn>
          </div>
        </div>
      </v-card>

      <h5 style="padding: 10px; margin-top: 0px; background: #222d32; color: #fff; font-weight: bold">
        Saldo acumulado: {{ saldoFinal >= 0 ? formatUtils.formatPrice(saldoFinal) : "(" + formatUtils.formatPrice(Math.abs(saldoFinal)) + ")" }}
      </h5>

      <v-card>
        <v-card-title>
          <span class="text-uppercase">Movimientos</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="rowsWithBalance"
          :search="search"
          :loading="loading"
          loading-text="Cargando..."
          :options="{ itemsPerPage: 15 }"
          :footer-props="{ itemsPerPageOptions: [5, 10, 15, 50, -1] }"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.tesoreria_movement.date }}</td>
              <td style="cursor: pointer; color: #1976d2; font-weight: bold" @click="viewItem(props.item)">{{ props.item.tesoreria_movement.nro_mov }}</td>
              <td>{{ props.item.tesoreria_movement.clase_comprobante ? props.item.tesoreria_movement.clase_comprobante.name : "-" }}</td>
              <td>{{ props.item.tesoreria_movement.concept || "-" }}</td>
              <td>{{ props.item.tesoreria_movement.reference || "-" }}</td>
              <td>{{ props.item?.concepto?.name || "-" }}</td>
              <td>{{ props.item.tesoreria_movement.description || "-" }}</td>
              <td class="text-right">
                {{ props.item.movement_type === "D" ? formatUtils.formatPrice(props.item.amount) : "-" }}
              </td>
              <td class="text-right">
                {{ props.item.movement_type === "H" ? formatUtils.formatPrice(props.item.amount) : "-" }}
              </td>
              <td class="text-right" :class="props.item.saldo >= 0 ? '' : 'red--text'">
                {{ props.item.saldo >= 0 ? formatUtils.formatPrice(props.item.saldo) : "(" + formatUtils.formatPrice(Math.abs(props.item.saldo)) + ")" }}
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Búsqueda sin resultados - " + search }}
            </v-alert>
          </template>
          <template v-slot:no-data>
            <v-alert class="mt-4" :value="true" color="info" icon="info"> No hay movimientos para el período seleccionado. </v-alert>
          </template>
        </v-data-table>
      </v-card>
      <Modal modal_title="Movimiento de Tesorería" :formBtn="''" :dialog="dialog" :item="mainItem" :service="tesoreriaMovementService" @updateDialog="updateDialog" @loadList="() => {}" />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { tesoreriaMovementService } from "@/libs/ws/tesoreriaMovementService";
import { formatUtils } from "@/libs/utils/formatUtils";
import Title from "@/components/Title.vue";
import Modal from "@/views/Treasury/TesoreriaMovements/Modal.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";

export default {
  components: { Title, Modal },
  mixins: [ExportMixin],
  data() {
    return {
      Constant,
      formatUtils,
      tesoreriaMovementService: tesoreriaMovementService,
      moneyAccountId: null,
      moneyAccountName: "",
      loading: false,
      loadingModal: false,
      dialog: false,
      mainItem: { id: "", date: "", clase_comprobante: null, emitter: null, concept: "", reference: "", details: [] },
      search: "",
      list: [],
      saldo_anterior: 0,
      desde_selected_open: false,
      hasta_selected_open: false,
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
      headers: [
        { text: "Fecha", align: "left", sortable: true, value: "date" },
        { text: "Nº Mov", align: "left", sortable: true, value: "nro_mov" },
        { text: "Comprobante", align: "left", sortable: true, value: "clase_comprobante.name" },
        { text: "Concepto del Mov.", align: "left", sortable: true, value: "concept" },
        { text: "Referencia", align: "left", sortable: true, value: "reference" },
        { text: "Concepto", align: "left", sortable: false, value: "concepto.name" },
        { text: "Descripción de la linea", align: "left", sortable: false, value: "description" },
        { text: "Debe", align: "right", sortable: false, value: "" },
        { text: "Haber", align: "right", sortable: false, value: "" },
        { text: "Saldo", align: "right", sortable: false, value: "saldo" },
      ],
    };
  },
  computed: {
    rowsWithBalance() {
      // La lista viene en ORDER DESC (más reciente primero).
      // Para calcular el saldo acumulado correctamente, iteramos de atrás
      // hacia adelante (de más antiguo a más reciente), partiendo del saldo_anterior.
      const items = this.list.map((d) => ({ ...d }));
      let saldo = this.saldo_anterior;
      for (let i = items.length - 1; i >= 0; i--) {
        const amount = parseFloat(items[i].amount || 0);
        saldo = items[i].movement_type === "D" ? saldo + amount : saldo - amount;
        items[i].saldo = Math.round(saldo * 100) / 100;
      }
      return items;
    },
    totalDebe() {
      return this.list.filter((d) => d.movement_type === "D").reduce((acc, d) => acc + parseFloat(d.amount || 0), 0);
    },
    totalHaber() {
      return this.list.filter((d) => d.movement_type === "H").reduce((acc, d) => acc + parseFloat(d.amount || 0), 0);
    },
    saldoNeto() {
      return Math.round((this.totalDebe - this.totalHaber) * 100) / 100;
    },
    saldoFinal() {
      return Math.round((this.saldo_anterior + this.totalDebe - this.totalHaber) * 100) / 100;
    },
  },
  mounted() {
    this.moneyAccountId = this.$route.params.money_account_id;
    this.moneyAccountName = this.$route.query.name || "Cuenta #" + this.moneyAccountId;
    this.loadBalances();
  },
  methods: {
    normalizeDetails(item) {
      if (item.details) {
        item.details = item.details.map((d) => ({
          ...d,
          amount_debe: d.movement_type === "D" ? d.amount : null,
          amount_haber: d.movement_type === "H" ? d.amount : null,
        }));
      }
      return item;
    },
    viewItem(detailRow) {
      this.loadingModal = true;
      tesoreriaMovementService
        .get({ id: detailRow.tesoreria_movement.id })
        .then((r) => {
          if (r.status) {
            this.mainItem = this.normalizeDetails(JSON.parse(JSON.stringify(r.result)));
            this.dialog = true;
          } else {
            this.$toast.error(r.msg || "Error al cargar el movimiento.", "Error");
          }
        })
        .catch((e) => {
          this.$toast.error((e && e.message) || "Error al cargar el movimiento.", "Error");
        })
        .finally(() => {
          this.loadingModal = false;
        });
    },
    exportFile() {
      var param = {
        money_account_id: this.moneyAccountId,
        date_from: this.desde_selected,
        date_to: this.hasta_selected,
        export: true,
        money_account_name: this.moneyAccountName,
      };
      this.exportExcel(Constant.SECTION_TESORERIA_MOVEMENTS + "/balance_by_account", param, "Balance-Cuenta-" + this.moneyAccountName + ".xlsx");
    },
    updateDialog(val) {
      this.dialog = val;
    },
    loadBalances() {
      if (!this.moneyAccountId) return;
      this.loading = true;
      tesoreriaMovementService
        .balanceByAccount({
          money_account_id: this.moneyAccountId,
          date_from: this.desde_selected,
          date_to: this.hasta_selected,
        })
        .then((r) => {
          if (r.status) {
            this.saldo_anterior = r.result.saldo_anterior || 0;
            this.list = r.result.details || [];
          } else {
            this.$toast.error(r.msg || "Error al cargar movimientos.", "Error");
          }
        })
        .catch((e) => {
          this.$toast.error((e && e.message) || "Error al cargar movimientos.", "Error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
